import {
  withTranslation,
} from 'react-i18next';

import ResultsSectionView from './ResultsSectionView';

const TranslatedComponent = withTranslation()(ResultsSectionView);

const Component = TranslatedComponent;

export default Component;
